var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MTableCell',{staticClass:"m-table-cell-dropdown-trigger",class:{'m-table-cell-dropdown-trigger_disabled' : !_vm.dropdownEnabled},on:{"click":_vm.handleTrigger}},[_c('div',{class:{'m-table-cell-dropdown-trigger__button': _vm.dropdownEnabled}},[_c('MIcon',{staticClass:"m-table-cell-dropdown-trigger__state-icon",class:{
        'm-table-cell-dropdown-trigger__state-icon_opened': _vm.dropdownActive,
        'm-table-cell-dropdown-trigger_disabled': !_vm.dropdownEnabled
      },attrs:{"icon":_vm.iconArrowDown}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }